"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _flickity = _interopRequireDefault(require("flickity"));

var RecommendationCarousel = /*#__PURE__*/function () {
  function RecommendationCarousel(component) {
    (0, _classCallCheck2["default"])(this, RecommendationCarousel);
    this.dom = {
      $component: component,
      $carousel: component.querySelector('.js-recommendation-carousel')
    }, this.state = {
      carousel: false
    };
    this.mount();
  }

  (0, _createClass2["default"])(RecommendationCarousel, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom;
      console.log('RecommendationCarousel : mount', this);
      this.initCarousel();
    }
  }, {
    key: "unmount",
    value: function unmount() {
      console.log('RecommendationCarousel : unmount', this);
    }
  }, {
    key: "initCarousel",
    value: function initCarousel() {
      var dom = this.dom,
          state = this.state;
      console.log('RecommendationCarousel : initCarousel', this);

      if (dom.$carousel) {
        state.carousel = new _flickity["default"](dom.$carousel, {
          prevNextButtons: false,
          groupCells: true,
          cellAlign: 'center',
          freeScroll: false,
          contain: false,
          pageDots: false,
          adaptiveHeight: false,
          selectedAttraction: 0.0275,
          friction: 0.3
        });
      }
    }
  }]);
  return RecommendationCarousel;
}();

exports["default"] = RecommendationCarousel;